<template>
  <div
    v-if="src && src.includes('image')"
    class="file group/file relative flex cursor-pointer flex-col items-center justify-start rounded-md text-[3.125rem] text-accent
           [transition:all_0.22s]
           after:absolute after:top-0 after:left-0 after:size-full after:rounded-[0.125rem] after:content-['']
           after:will-change-[box-shadow] after:[transition:box-shadow_0.22s]
           [&:hover]:after:shadow-[1px_1px_8px_var(--shadow-color)]"
  >
    <div class="file-icon-size relative flex w-full items-center justify-between">
      <div v-if="!isPreview" style="flex: 1;"></div>
      <img
        ref="img"
        class="image-file size-15.5 rounded-md object-cover"
        :src="src"
        :height="imageHeight"
        :width="imageWidth"
        @load="onImageLoaded($event)"
      />
      <div v-if="!isPreview" class="file-extension">{{ extension }}</div>
      <div
        class="file-size absolute top-[35%] left-1/2 flex flex-1 -translate-x-1/2 text-center text-[0.4375rem] text-text-soft
               opacity-0 [transition:opacity_0.22s] group-[:hover]/file:opacity-100"
      >{{ isPreview ? filename : size }}</div>
    </div>
    <div v-if="!isPreview" class="file-name hidden">
      {{ filename }}
    </div>
  </div>
  <div
    v-else
    class="file group/file relative flex cursor-pointer flex-col items-center justify-start rounded-md bg-input text-[3.125rem] text-accent
           shadow-[0_0_0_1px_var(--line)] [transition:all_0.22s]
           after:absolute after:top-0 after:left-0 after:size-full after:rounded-[0.125rem] after:content-['']
           after:will-change-[box-shadow] after:[transition:box-shadow_0.22s]
           [&:hover]:after:shadow-[1px_1px_8px_var(--shadow-color)]"
    :class="extendedInfo ? 'file-extended-info mt-1 mb-[0.6875rem]' : 'file-info'"
    :title="filename"
  >
    <div class="file-item flex items-center" :class="extendedInfo ? 'w-50 p-2.5' : 'w-32 px-2.5 py-2'">
      <div class="file-item__icon flex items-center">
        <span :class="[`fiv-cla fiv-icon-${extension.toLowerCase()}`, extendedInfo ? 'h-10' : 'h-7 text-[1.75rem]']"></span>
      </div>
      <div class="file-item__info flex min-w-0 flex-1 flex-col">
        <div
          class="file-item__info-name ml-2.5 truncate font-medium text-text-soft"
          :class="extendedInfo ? 'text-group' : 'text-body'"
        >
          {{ filename }}
        </div>
        <div v-if="extendedInfo" class="file-item__info-size ml-2.5 truncate text-label text-text-soft">
          {{ size }} <span v-if="upload" class="ml-[0.3125rem] text-[0.625rem] text-accent">{{ Math.floor((upload.loaded / upload.total) * 100) }}%</span>
        </div>
      </div>
      <div
        v-if="extendedInfo"
        class="file-item-download ml-5 text-[1.125rem] text-text-soft opacity-0 [transition:all_0.5s] group-[:hover]/file:opacity-100"
      >
        <i class="tr tr-download"></i>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue';
import { uploads } from '@/utils/uploadQueue';


const props = defineProps({
  src: {
    type: String,
    required: false,
  },
  filename: String,
  size: String,
  extension: String,
  type: String,
  extendedInfo: {
    type: Boolean,
    default: false,
  },
  attachmentId: String,
});

const imageWidth = ref('');
const imageHeight = ref('');

const isPreview = computed(() => props.type === 'preview');

const upload = computed(() => uploads.find(u => u.id === props.attachmentId));



function onImageLoaded() {
  const image = document.querySelector('.image-file');
  const imageWidthNumber = +image.width;
  const imageHeightNumber = +image.height;
  const maxWidthNumber = 100;
  const maxHeightNumber = 50;

  if (imageWidthNumber > maxWidthNumber || imageHeightNumber > maxHeightNumber) {
    if (imageWidthNumber > imageHeightNumber) {
      const ratio = imageWidthNumber / maxWidthNumber;

      imageWidth.value = maxWidthNumber;
      imageHeight.value = imageHeightNumber / ratio;
    } else {
      const ratio = imageHeightNumber / maxHeightNumber;

      imageHeight.value = maxHeightNumber;
      imageWidth.value = imageWidthNumber / ratio;
    }
  } else {
    imageWidth.value = imageWidthNumber;
    imageHeight.value = imageHeightNumber;
  }
}
</script>
